import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from 'react';
import { BreadcrumbsProps } from '@otp/ui';

export interface PageContextType {
  header: string;
  setHeader: Dispatch<SetStateAction<string>>;
  breadcrumbs?: BreadcrumbsProps;
  setBreadcrumbs: Dispatch<SetStateAction<BreadcrumbsProps | undefined>>;
}

const PageContext = createContext<PageContextType>({} as PageContextType);

function usePageContext() {
  return useContext(PageContext);
}

function PageContextProvider({ children }: { children?: React.ReactNode }) {
  const [header, setHeader] = useState<string>('');
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbsProps>();

  const value: PageContextType = {
    header,
    setHeader,
    breadcrumbs,
    setBreadcrumbs,
  };

  return <PageContext.Provider value={value}>{children}</PageContext.Provider>;
}

export { PageContextProvider, usePageContext };
